import { render, staticRenderFns } from "./move-type-add-or-update.vue?vue&type=template&id=36fc251a"
import script from "./move-type-add-or-update.vue?vue&type=script&lang=js"
export * from "./move-type-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports